import React from 'react';

const ContractPreview = ({ data }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  };

  const calculateTotal = () => {
    const productsTotal = data.products.reduce(
      (total, product) => total + (product.totalPrice || 0), 
      0
    );
    
    // Adicionar custo de entrega se houver
    const deliveryFee = data.delivery?.fee || 0;
    
    return productsTotal + deliveryFee;
  };

  return (
    <div className="text-sm text-gray-800 space-y-6 font-serif">
      <div className="text-center font-bold text-lg mb-6">
        CONTRATO DE COMPRA E VENDA
      </div>
      
      <p className="text-justify">
        Pelo presente instrumento particular de compromisso de compra e venda, de um lado
        COOPERATIVA DE PRODUTOS EXTRATIVISTA DO DELTA - COOPDELTA, com sede
        na cidade de Araioses-MA, Rua Rua Beira Mar S/N, Povoado Carnaubeiras, Araioses, MA,
        CEP 65570-000, inscrita no CNPJ sob o nº 53.034.052/0001-45, de ora adiante chamado de
        VENDEDORA, e do outro lado…
      </p>
      
      {data.buyer?.type === 'pf' ? (
        <p>
          {data.buyer.name || 'Sr. _______________'}, 
          {data.buyer.address ? ` residente na ${data.buyer.address},` : ''} 
          {data.buyer.city && data.buyer.state ? ` ${data.buyer.city}-${data.buyer.state}` : ''}
          {data.buyer.cpf ? ` portador do CPF nº ${data.buyer.cpf},` : ''} doravante denominado(a) COMPRADOR, 
          têm, entre si, como justo e contratado o que se segue:
        </p>
      ) : (
        <p>
          {data.buyer?.companyName || 'Empresa _______________'}, 
          {data.buyer?.address ? ` com sede na ${data.buyer.address},` : ''} 
          {data.buyer?.city && data.buyer?.state ? ` ${data.buyer.city}-${data.buyer.state},` : ''}
          {data.buyer?.cnpj ? ` inscrita no CNPJ sob o nº ${data.buyer.cnpj},` : ''} 
          representada pelo Sr. {data.buyer?.representative || '_______________'},
          {data.buyer?.representativeCpf ? ` portador do CPF nº ${data.buyer.representativeCpf},` : ''} 
          doravante denominado(a) COMPRADOR, têm, entre si, como justo e contratado o que se segue:
        </p>
      )}
      
      <div>
        <p className="font-bold mb-2">CLÁUSULA PRIMEIRA – DO OBJETO</p>
        <p className="text-justify">
          A VENDEDORA vende ao COMPRADOR, pelo preço certo e ajustado de {formatCurrency(calculateTotal())} 
          ({/* Valor por extenso */}) o seguinte:
        </p>
        
        <div className="my-4 border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                  Item
                </th>
                <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                  Qnt/Uni
                </th>
                <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                  Especificação
                </th>
                <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                  Preço Unitário
                </th>
                <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                  Preço Total
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.products && data.products.map((product, index) => (
                <tr key={index}>
                  <td className="px-4 py-2 whitespace-nowrap text-xs">
                    {index + 1}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap text-xs">
                    {product.quantity} {product.unit}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap text-xs">
                    {product.name}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap text-xs">
                    {formatCurrency(product.unitPrice)}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap text-xs">
                    {formatCurrency(product.totalPrice)}
                  </td>
                </tr>
              ))}
              <tr className="bg-gray-50">
                <td colSpan="4" className="px-4 py-2 text-right text-xs font-medium">
                  Valor total da mercadoria
                </td>
                <td className="px-4 py-2 text-xs font-medium">
                  {formatCurrency(data.products?.reduce((total, product) => total + (product.totalPrice || 0), 0) || 0)}
                </td>
              </tr>
              <tr>
                <td colSpan="4" className="px-4 py-2 text-right text-xs font-medium">
                  Valor da entrega
                </td>
                <td className="px-4 py-2 text-xs font-medium">
                  {formatCurrency(data.delivery?.fee || 0)}
                </td>
              </tr>
              <tr className="bg-gray-100">
                <td colSpan="4" className="px-4 py-2 text-right text-xs font-bold">
                  Valor total
                </td>
                <td className="px-4 py-2 text-xs font-bold">
                  {formatCurrency(calculateTotal())}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div>
        <p className="font-bold mb-2">CLÁUSULA SEGUNDA – GARANTIA</p>
        <p className="text-justify">
          Os produtos vendidos estão de acordo com as normas sanitárias vigentes e com as condições
          de conservação informadas no ato da venda. A garantia refere-se exclusivamente à qualidade
          do produto entregue, sendo a VENDEDORA responsável por eventuais defeitos de origem
          constatados no momento da entrega, conforme artigo 50 do Código de Defesa do
          Consumidor.
        </p>
      </div>
      
      <div>
        <p className="font-bold mb-2">
          CLÁUSULA TERCEIRA – PAGAMENTO 
          {data.payment?.type === 'prazo' ? '(A PRAZO)' : '(À VISTA)'}
        </p>
        
        {data.payment?.type === 'prazo' ? (
          <>
            <p className="text-justify">
              O valor total da compra, {formatCurrency(calculateTotal())},
              será pago a prazo de forma parcelada, conforme abaixo:
            </p>
            
            <div className="my-4 border border-gray-200">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                      Parcela
                    </th>
                    <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                      Valor
                    </th>
                    <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                      Data
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {data.payment?.installments && data.payment.installments.map((installment, index) => (
                    <tr key={index}>
                      <td className="px-4 py-2 whitespace-nowrap text-xs">
                        {index + 1}
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap text-xs">
                        {formatCurrency(installment.amount)}
                      </td>
                      <td className="px-4 py-2 whitespace-nowrap text-xs">
                        {formatDate(installment.date)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <p className="font-medium text-xs mb-2">Forma de Pagamento:</p>
            <div className="space-y-1 ml-4">
              <div className="flex items-start">
                <div className="w-4 h-4 border border-gray-300 mt-0.5 mr-2 flex justify-center items-center">
                  {data.payment?.method === 'boleto' && <div className="w-2 h-2 bg-black rounded-full" />}
                </div>
                <span className="text-xs">Boleto bancário emitido pela Cooperativa</span>
              </div>
              <div className="flex items-start">
                <div className="w-4 h-4 border border-gray-300 mt-0.5 mr-2 flex justify-center items-center">
                  {data.payment?.method === 'cartao-credito' && <div className="w-2 h-2 bg-black rounded-full" />}
                </div>
                <span className="text-xs">Cartão de crédito (sujeito a acréscimos)</span>
              </div>
              <div className="flex items-start">
                <div className="w-4 h-4 border border-gray-300 mt-0.5 mr-2 flex justify-center items-center">
                  {data.payment?.method === 'pix-mensal' && <div className="w-2 h-2 bg-black rounded-full" />}
                </div>
                <span className="text-xs">Transferência bancária/pix mensal</span>
              </div>
            </div>
          </>
        ) : (
          <>
            <p className="text-justify">
              O pagamento do objeto contratual será realizado à vista, no valor total de {formatCurrency(calculateTotal())},
              correspondente aos produtos descritos na Cláusula Primeira.
            </p>
            
            <p className="font-medium text-xs mb-2">Forma de Pagamento:</p>
            <div className="space-y-1 ml-4">
              <div className="flex items-start">
                <div className="w-4 h-4 border border-gray-300 mt-0.5 mr-2 flex justify-center items-center">
                  {data.payment?.method === 'especie' && <div className="w-2 h-2 bg-black rounded-full" />}
                </div>
                <span className="text-xs">Em espécie</span>
              </div>
              <div className="flex items-start">
                <div className="w-4 h-4 border border-gray-300 mt-0.5 mr-2 flex justify-center items-center">
                  {data.payment?.method === 'boleto' && <div className="w-2 h-2 bg-black rounded-full" />}
                </div>
                <span className="text-xs">Boleto bancário emitido pela Cooperativa</span>
              </div>
              <div className="flex items-start">
                <div className="w-4 h-4 border border-gray-300 mt-0.5 mr-2 flex justify-center items-center">
                  {data.payment?.method === 'cartao-debito' && <div className="w-2 h-2 bg-black rounded-full" />}
                </div>
                <span className="text-xs">Cartão de débito (sujeito a acréscimos)</span>
              </div>
              <div className="flex items-start">
                <div className="w-4 h-4 border border-gray-300 mt-0.5 mr-2 flex justify-center items-center">
                  {data.payment?.method === 'pix' && <div className="w-2 h-2 bg-black rounded-full" />}
                </div>
                <span className="text-xs">Transferência bancária/pix</span>
              </div>
            </div>
            
            <p className="text-justify mt-4">
              O presente contrato só será considerado plenamente vigente após a efetiva comprovação do
              pagamento integral.
            </p>
          </>
        )}
      </div>
      
      <div>
        <p className="font-bold mb-2">CLÁUSULA QUARTA – RETIRADA/ENTREGA</p>
        
        {data.delivery?.type === 'retirada' ? (
          <p className="text-justify">
            Os produtos adquiridos serão retirados pelo COMPRADOR 
            {data.payment?.type === 'vista' ? ' no ato da compra, após a efetiva comprovação do pagamento integral.' : ' no ato da compra, após a assinatura do contrato.'}
          </p>
        ) : (
          <p className="text-justify">
            Os produtos adquiridos serão entregues posteriormente, conforme encomenda. A entrega será realizada no endereço informado pelo COMPRADOR, conforme combinado previamente entre as partes.
          </p>
        )}
        
        {data.delivery?.type === 'entrega' && (
          <div className="space-y-2 my-4">
            <p className="font-medium text-xs">Endereço completo:</p>
            <p className="text-xs ml-4">
              {data.delivery.address || '_______________'}
            </p>
            <p className="text-xs ml-4">
              CEP: {data.delivery.zipCode || '_______________'}
            </p>
          </div>
        )}
        
        {data.delivery?.dates && data.delivery.dates.length > 0 && (
          <div className="my-4">
            <p className="font-medium text-xs mb-2">
              A {data.delivery?.type === 'entrega' ? 'entrega' : 'retirada'} será realizada conforme cronograma abaixo:
            </p>
            
            {data.delivery.dates.map((dateGroup, dateIndex) => (
              <div key={dateIndex} className="mb-4">
                <div className="bg-gray-50 px-4 py-2 text-xs font-medium">
                  Data/Horário: {formatDate(dateGroup.date)}, das 10h às 16h
                </div>
                
                <div className="border border-gray-200">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                          Item
                        </th>
                        <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                          Qnt/Uni
                        </th>
                        <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500">
                          Especificação
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {dateGroup.items && dateGroup.items.map((product, index) => (
                        <tr key={index}>
                          <td className="px-4 py-2 whitespace-nowrap text-xs">
                            {index + 1}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-xs">
                            {product.quantity} {product.unit}
                          </td>
                          <td className="px-4 py-2 whitespace-nowrap text-xs">
                            {product.name}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        )}
        
        <p className="text-justify">
          Para a {data.delivery?.type === 'entrega' ? 'realização da entrega' : 'retirada'}, é necessária a efetiva comprovação do 
          {data.payment?.type === 'vista' ? ' pagamento integral.' : ' pagamento das parcelas vencidas.'}
        </p>
        
        {data.delivery?.type === 'entrega' && (
          <p className="text-justify mt-2">
            Caso o COMPRADOR não esteja presente no local informado para recebimento, será de sua
            responsabilidade providenciar e arcar com os custos de uma nova tentativa de entrega ou
            realizar a retirada diretamente no local designado pela VENDEDORA, sem direito a
            reembolso ou abatimento do valor pago.
          </p>
        )}
        
        <p className="text-justify mt-2">
          Tratando-se de mercadoria perecível, em caso de perda da mesma por conduta falha do
          COMPRADOR quando da {data.delivery?.type === 'entrega' ? 'entrega' : 'retirada'}, dar-se-á como plenamente cumprida a
          responsabilidade da VENDEDORA, sendo responsabilidade do COMPRADOR arcar com
          quaisquer prejuízos causados por sua própria conduta.
        </p>
      </div>
      
      <div>
        <p className="font-bold mb-2">CLÁUSULA QUINTA – IMPONTUALIDADE DO PAGAMENTO</p>
        <p className="text-justify">
          O pagamento não realizado pelo COMPRADOR na data pactuada entre os contratantes,
          incidirá em:
        </p>
        <p className="text-justify">
          a) multa penal de 2% (dois) sobre o valor;<br />
          b) correção monetária de acordo com o índice IPCA;<br />
          c) juros de 2% (dois) ao mês.
        </p>
      </div>
      
      <div>
        <p className="font-bold mb-2">CLÁUSULA SEXTA – INADIMPLEMENTO CONTRATUAL</p>
        <p className="text-justify">
          Ocorrendo a inadimplência do pagamento da obrigação assumida pelo COMPRADOR, além
          do ônus previsto na cláusula anterior, o COMPRADOR, será responsável por todas as
          despesas que a VENDEDORA tiver de dispor que para realizar a cobrança extrajudicial e
          judicial, realizado diretamente pelo seu departamento de cobrança ou por terceiros que
          prestem este serviço.
        </p>
      </div>
      
      <div>
        <p className="font-bold mb-2">CLÁUSULA SÉTIMA – FORO</p>
        <p className="text-justify">
          As partes elegem o foro da comarca de Araioses-MA para dirimir as questões oriundas deste
          contrato, com renúncia de qualquer outro, por mais privilegiado que seja.
        </p>
        <p className="text-justify mt-4">
          E por estarem as partes, COMPRADOR e VENDEDORA, em pleno acordo, em tudo quanto
          se encontra disposto neste instrumento particular, assinam-no na presença das duas
          testemunhas abaixo, garantido o envio de 1 via para cada contratante.
        </p>
      </div>
      
      <div className="mt-8 text-center">
        <p>Araioses - MA, _____ de __________________ de {new Date().getFullYear()}.</p>
      </div>
      
      <div className="mt-8 space-y-12">
        <div className="text-center border-t border-gray-400 pt-2 w-64 mx-auto">
          <p>
            {data.buyer?.type === 'pf' 
              ? (data.buyer.name || '_______________') 
              : (data.buyer?.representative || '_______________')}
          </p>
          <p className="text-xs">
            {data.buyer?.type === 'pf' 
              ? `CPF: ${data.buyer.cpf || '_______________'}` 
              : `${data.buyer?.companyName || '_______________'}`}
          </p>
          <p className="font-medium">COMPRADOR</p>
        </div>
        
        <div className="text-center border-t border-gray-400 pt-2 w-64 mx-auto">
          <p>Paulo Alves Menezes</p>
          <p className="font-medium">Presidente da Coopdelta</p>
          <p className="font-medium">VENDEDORA</p>
        </div>
        
        <div className="grid grid-cols-2 gap-8 mt-12">
          <div className="text-center border-t border-gray-400 pt-2">
            <p>_______________</p>
            <p className="text-xs">Testemunha 1</p>
            <p className="text-xs">CPF: _______________</p>
          </div>
          
          <div className="text-center border-t border-gray-400 pt-2">
            <p>_______________</p>
            <p className="text-xs">Testemunha 2</p>
            <p className="text-xs">CPF: _______________</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractPreview;